<template>
  <div class="home-header">
    <h1>{{ title }}</h1>
    <span class="small-text">{{ smallText }}</span>
    <div class="home-description" v-html="$t(description)">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  props: {
    title: String,
    description: String,
    smallText: String
  }
}
</script>

<style scoped lang="scss">
.home-header {
  text-align: center;
}
h1 {
  text-align: center;
  color: #010101;
  margin: 72px auto 0;
  display: block;
  padding: 10px;
  font-style: normal;
  font-weight: bold;
  font-size: 38px;
  line-height: 45px;
}

.small-text {
  display: block;
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #010101;
}

.home-description {
  font-style: normal;
  font-weight: normal;
  font-size: 21px;
  line-height: 28px;
  text-align: center;
  color: #6E777A;
  max-width: 740px;
  margin: 0 auto;
}
</style>
